/* eslint-disable react-refresh/only-export-components */
import { useState } from "react";
import { useTranslate } from "ra-core";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { LEADBOXER_BRANDS } from "./leadboxer/instances";
import type { LeadboxerInstance } from "./leadboxer/types";
import { VisitorLeadsTable } from "./VisitorLeadsTable";

export const VisitorInsightsPage = () => {
  const translate = useTranslate();
  const [activeInstance, setActiveInstance] = useState<LeadboxerInstance>(
    "gobo-dk",
  );

  const isDemo = import.meta.env.VITE_IS_DEMO === "true";

  if (isDemo) {
    return (
      <div className="max-w-4xl mx-auto mt-8 px-4">
        <Card>
          <CardHeader>
            <CardTitle>
              {translate("crm.visitor_insights.title", {
                _: "Visitor Insights",
              })}
            </CardTitle>
          </CardHeader>
          <CardContent className="text-muted-foreground">
            {translate("crm.visitor_insights.demo_unavailable", {
              _: "Visitor Insights requires Leadboxer configuration and is not available in demo mode.",
            })}
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto mt-4 px-4 pb-8">
      <Card>
        <CardHeader className="pb-0">
          <CardTitle>
            {translate("crm.visitor_insights.title", {
              _: "Visitor Insights",
            })}
          </CardTitle>
          <p className="text-sm text-muted-foreground">
            {translate("crm.visitor_insights.description", {
              _: "View identified organizations visiting your websites.",
            })}
          </p>
        </CardHeader>
        <CardContent className="pt-6">
          <Tabs
            value={activeInstance}
            onValueChange={(value) =>
              setActiveInstance(value as LeadboxerInstance)
            }
          >
            <TabsList className="w-full flex flex-wrap h-auto gap-1 justify-start">
              {LEADBOXER_BRANDS.map((brand) => (
                <TabsTrigger key={brand.id} value={brand.id}>
                  {translate(brand.labelKey, { _: brand.fallback })}
                </TabsTrigger>
              ))}
            </TabsList>
            {LEADBOXER_BRANDS.map((brand) => (
              <TabsContent key={brand.id} value={brand.id} className="mt-6">
                <div className="mb-4">
                  <h2 className="text-lg font-medium">
                    {translate("crm.visitor_insights.brand_title", {
                      brand: translate(brand.labelKey, { _: brand.fallback }),
                      _: "%{brand} Visitor Insights",
                    })}
                  </h2>
                  <p className="text-sm text-muted-foreground">
                    {translate("crm.visitor_insights.brand_description", {
                      brand: translate(brand.labelKey, { _: brand.fallback }),
                      _: "Website visitor data for %{brand}.",
                    })}
                  </p>
                </div>
                <VisitorLeadsTable instance={brand.id} />
              </TabsContent>
            ))}
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
};

VisitorInsightsPage.path = "/visitor-insights";
